import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valCondition',
  standalone: false
})
export class ValConditionPipe implements PipeTransform {

  transform(condition: string) {
    return getConditionValue(condition);
  }

}

export function getConditionValue(condition: string){
  let value: number=0;

  switch(condition){
    case 'PO':
      value=0;
      break; 
    case 'PL':
    case 'LP':
      value=1;
      break;
    case 'EX':
      value=2;
      break;
    case 'GD':
      value=3;
      break;
    case 'NM':
      value=4;
      break;
    case 'M':
      value=5;
      break;
    default: 
      value=0;
      break;
  }

  return value;
}
